import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {User} from '@app/shared';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  loggedUser$: BehaviorSubject<User | undefined> = new BehaviorSubject<User | undefined>(undefined);

  get loggedUser(): Observable<User | undefined> {
    return this.loggedUser$ as Observable<User | undefined>;
  }

  set loggedUser(value: User | undefined) {
    // Se definen los permisos segun el rol
    if (value) {
      value.viewMaestros = value.roleId === 7 || value.roleId === 1 || value.roleId === 2 || value.roleId === 3;
      value.viewOnlyDriversEquipmentsMaestros = value.roleId === 4;
      value.viewAdministracion = value.roleId === 7 || value.roleId === 1 || value.roleId === 3;
      value.viewMoneyData = value.roleId !== 4;
      value.viewUnassignedProjectsAndServices = value.roleId !== 4;
      value.editProject = value.roleId === 5 || value.roleId === 7 || value.roleId === 1;
      value.createContainers = value.roleId === 5 || value.roleId === 7 || value.roleId === 1 || value.roleId === 2;
      value.editService = value.roleId === 2 || value.roleId === 7 || value.roleId === 1;
      value.generateOrders = value.roleId === 2 || value.roleId === 7 || value.roleId === 1 || value.roleId === 3;
      value.validateOrders = value.roleId === 7 || value.roleId === 1 || value.roleId === 3;
      value.emitAndSendOrders = value.roleId === 2;
      value.reviewOrders = value.roleId === 5;
      value.approveOrders = value.roleId === 5 || value.roleId === 2;
      value.uploadDocumentsUnlimited = value.roleId !== 4 && value.roleId !== 6;
      value.validateDocuments = value.roleId !== 4 && value.roleId !== 6;
      value.uploadDocumentsLimited = value.roleId === 4;
      value.editSOLimited = value.roleId === 4;
      value.editSOUnlimited = value.roleId === 2 || value.roleId === 7 || value.roleId === 1;
      value.viewAndEditTransportSectionSO = value.roleId === 4;
      value.createProject = value.roleId !== 4 && value.roleId !== 6;
      value.createService = value.roleId !== 4 && value.roleId !== 6;
    }
    this.loggedUser$.next(value);
  }
}
